export const getByRef = (state) => (ref) =>
  state.items.find((item) => item.ref === ref)

export const get = (state) => state.items
